import { createI18n } from 'vue-i18n'
import ru from './locales/ru.json'
import en from './locales/en.json'
import kk from './locales/kk.json'
import bz from './locales/bz.json'
// import pt from './locales/pt.json'
import de from './locales/de.json'
import fr from './locales/fr.json'
import es from './locales/es.json'

// Языки, при которых используем русскую локализацию
const ruPreferredLanguages = ['ru', 'uk', 'be', 'kk', 'uz', 'ky', 'tg', 'tk', 'az', 'hy', 'ro']

// Функция для определения языка по браузеру
const getBrowserLocale = () => {
  const lang = navigator.language || navigator.userLanguage
  const baseLang = lang.split('-')[0]

  const localesMap = {
    en: 'en',
    'pt-BR': 'bz',
    pt: 'bz',
    kk: 'kk',
    ru: 'ru',
    fr: 'fr',
    de: 'de',
    es: 'es'
  }

  // Приоритет — карта соответствий, затем — список ru-языков
  return localesMap[lang] || localesMap[baseLang] ||
    (ruPreferredLanguages.includes(baseLang) ? 'ru' : 'en')
}

// Получаем язык из localStorage или определяем по браузеру
const savedLocale = localStorage.getItem('lang') || getBrowserLocale()

// Инициализация i18n
const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    ru,
    kk,
    bz,
    de,
    fr,
    es
  }
})

// Обработчик смены языка с сохранением
i18n.global.setLocaleMessage = (locale) => {
  i18n.global.locale = locale
  localStorage.setItem('lang', locale)
}

export default i18n
